import {svgIconWrapper} from '../svg-icon-wrapper';

import AircallRegular from './aircall-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <AircallRegular {...props} />;
}

SvgComponent.iconName = 'aircallRegular';

export const AircallRegularIcon = svgIconWrapper(SvgComponent);
